import { gql } from "@apollo/client";

export const GET_ALL_ORGANIZATIONS_INITIATIVE = gql`
  query Query($organizationId: String!, $initiativeId: String!) {
    getInitiativeOrganizations(
      organizationId: $organizationId
      initiativeId: $initiativeId
    ) {
      joinDate
      noOfCases
      organization {
        email
        id
        name
        logoUrl
      }
    }
  }
`;
